var e4 = e4 || {},
    visma = visma || {},
    anime = anime || {};

(function (func) {
    $.fn.addClass = function () { // replace the existing function on $.fn
        func.apply(this, arguments); // invoke the original function
        this.trigger('classChanged'); // trigger the custom event
        return this; // retain jQuery chainability
    }
})($.fn.addClass); // pass the original function as an argument

(function (func) {
    $.fn.removeClass = function () {
        func.apply(this, arguments);
        this.trigger('classChanged');
        return this;
    }
})($.fn.removeClass);

(function () {
    'use strict';
    jQuery(function () {
        visma.init();
    });
    visma.init = function () {
        visma.carousel.init();
        visma.anime.init();
        visma.newsCarousel.init();
        visma.navigation.init();
        visma.eloquaForm.init();
        visma.coursesAndWebinarsFiltering.init();
    };
    visma.cookieConsentExpirationForSafari = {
        init: function () {
            window.addEventListener("CookiebotOnConsentReady", function () {
                var c = Cookiebot,
                    d = document,
                    cookies = d.cookie.split(";"),
                    consentCookie = "",
                    consentDate = c.consentUTC,
                    consentExpiry = new Date(consentDate.setMonth(consentDate.getMonth() + 12)),
                    now = new Date();

                for (var i = 0; i < cookies.length; i++)
                    if (/^CookieConsent/g.test(cookies[i]))
                        consentCookie = cookies[i];
                if (consentCookie !== "" && now < consentExpiry)
                    d.cookie = consentCookie + ";expires=" + consentExpiry.toUTCString();
            });
        }
    };
    visma.eloquaForm = {
        init: function () {

            var eloquaFormMarketingText = jQuery('input[name="marketingUsageConsent1"]').next('.elq-item-label');
            var eloquaFormProfilingText = jQuery('input[name="privacyConsent1"]').next('.elq-item-label');

            jQuery('input[name="privacyConsent1"]').prop("checked", true).hide();
            eloquaFormProfilingText.removeClass('checkbox-aligned');
            eloquaFormProfilingText.addClass('small');
            eloquaFormMarketingText.addClass('small');

            if (eloquaFormMarketingText.length > -1) {
                eloquaFormMarketingText.html(window.gdprData.marketing.text);
            }

            if (eloquaFormProfilingText.length > -1) {
                eloquaFormProfilingText.html(window.gdprData.profiling.text + ' <a href="' + window.gdprData.profiling.url + '" target="_blank">' + window.gdprData.profiling.linktext + '</a>. ');
            }
        }
    };
    visma.searchclose = {
        init: function () {
            jQuery(document).click(function(e)
            {
                var searchContainer = jQuery('.e-search .modal-body');
                if (!searchContainer.is(e.target) && searchContainer.has(e.target).length === 0 && $('.js-e-search-modal').is(':visible'))
                {
                    jQuery(".js-e-search-modal").modal("hide");
                }
            });            
        }
    };
    visma.navigation = {
        init: function () {
            visma.navigation.bindEvents();
        },
        bindEvents: function () {
            jQuery('.e-nav-hamburger-header').on('click', '.js-toggle-hamburger-icon', function (event) {
                jQuery(event.target).closest('.hamburger').toggleClass('is-active');
            });

            jQuery('.js-e-header.is-transparent').on('classChanged', '.e-dropdown-mega', function (event) {

                if (jQuery(jQuery(event.target).closest('.e-dropdown-mega')).hasClass('show')) {
                    jQuery('.js-e-header').removeClass('is-transparent');
                    jQuery('.js-e-header').addClass('not-transparent-but-fixed');
                } else {
                    jQuery('.js-e-header').removeClass('not-transparent-but-fixed');
                    jQuery('.js-e-header').addClass('is-transparent');
                }

            });
        }
    };
    visma.newsCarousel = {
        init: function () {
            var leftPos = 0,
                idx = 0;

            var listItems = jQuery('.row.js-visma-section-left-amount'),
                totalItems = listItems.children().length;
            jQuery('.total-items').html(totalItems);

            jQuery('.carousel-control-next.control-arrow').click(function (event) {
                var parent = jQuery(event.target).closest('.visma-section-horizontal-carousel');
                idx += 1;
                idx = (idx > totalItems - 2) ? totalItems - 2 : idx;
                leftPos = idx * $(window).width() * 0.35;
                listItems.animate({marginLeft: -leftPos}, 300);
            });

            jQuery('.carousel-control-prev.control-arrow').click(function (event) {
                var parent = jQuery(event.target).closest('.visma-section-horizontal-carousel'),
                    listItems = jQuery('.row.js-visma-section-left-amount'),
                    totalItems = listItems.children.length;

                idx -= 1;
                idx = (idx < 0) ? 0 : idx;
                leftPos = -idx * $(window).width() * 0.35;
                listItems.animate({marginLeft: leftPos}, 300);
            });

        }
    };
    visma.anime = {
        init: function () {
            var arrTargets = jQuery('h1, h2').toArray();
            if ( e4.util.observer.isSupported === true ) {
                jQuery('h1, h2').each(function (index, currentElement) {

                    //currentElement.innerHTML = currentElement.textContent.replace(/([A-Za-z0-9-æ-ø-.-å-,'<>/]+)/g, "<span class='d-inline-block'><span class='word'>$1</span></span>");

                    var markedWord = jQuery(currentElement).closest('.p-imagetext').data("markedword");
                    if (markedWord !== undefined) {
                        markedWord = jQuery(currentElement).closest('.p-imagetext').data("markedword").toString();
                    }

                    var markedWordColor = 'text-' + jQuery(currentElement).closest('.p-imagetext').data("markedwordcolor");

                    currentElement.innerHTML = currentElement.textContent.replace(/([A-Za-z0-9-æ-ø-å?.'’‘!“”%:+<>/]+|,\B)/g, "<span class='word'>$1</span>");

                    if (currentElement.textContent.indexOf(markedWord) > -1) {

                        var arrMarkedWord = markedWord.split(' ');
                        var spanCollection = [];
                        var jCurrentElement = jQuery(currentElement);

                        jCurrentElement.find('.word').each(function (index, wordElement) {


                            var jWordElement = jQuery(wordElement);

                            var currentElementIndex = index;

                            if (jWordElement.text() === arrMarkedWord[0]) {

                                jQuery.each(arrMarkedWord, function (index, markedWordElement) {

                                    if (arrMarkedWord[index] === jQuery(jCurrentElement.find('.word')[currentElementIndex + index]).text()) {

                                        //console.log(arrMarkedWord[index], jQuery(jCurrentElement.find('.word')[currentElementIndex + index]).text())

                                        spanCollection.push(jCurrentElement.find('.word')[currentElementIndex + index]);
                                    }

                                })
                            } else {

                                jQuery.each(arrMarkedWord, function (index, markedWordElement) {

                                    if (jWordElement.text().indexOf(arrMarkedWord[index]) > -1 && arrMarkedWord[index].length > 0) {

                                        jWordElement.html(jWordElement.text().replace(arrMarkedWord[index], '<span class="' + markedWordColor + '">' + arrMarkedWord[index] + '</span>'))

                                    }

                                })

                            }
                        });

                        if (spanCollection.length > arrMarkedWord.length) {
                            jQuery(spanCollection[0]).addClass(markedWordColor);
                        } else {
                            jQuery(spanCollection).addClass(markedWordColor);
                        }


                    }


                    e4.util.observer.bind(arrTargets, function (domElm, observer) {

                        if (domElm.isIntersecting === true) {

                            jQuery('h1, h2').css('opacity', '1');

                            anime.timeline({loop: false})
                                .add({
                                    targets: 'h1 .word, .h1 .word, , .h2 .word, , h2 .word',
                                    translateY: ["1.1em", 0],
                                    translateZ: 0,
                                    duration: 1000,
                                    easing: 'easeInOutCubic',
                                    delay: 0,
                                    opacity: 1,
                                });

                            observer.unobserve(domElm.target);
                        }
                    });

                });
            } else {
                jQuery('h1, h2, .lead, .btn, img').css('opacity', '1');
            }
        }
    };
    visma.carousel = {
        init: function () {
            //slide counter
            
            jQuery('.js-visma-carousel-left-right').each(function (intIndex, domNode) {

                var currentIndex = jQuery(domNode).find('div.active').index() + 1;
                jQuery(domNode).find('.current-slide').html(currentIndex);
                jQuery(domNode).on('slid.bs.carousel', function () {
                    currentIndex = jQuery(domNode).find('div.active').index() + 1;
                    jQuery(domNode).find('.current-slide').html(currentIndex);
                });

                //text move
                jQuery(domNode).find('.js-visma-carousel-caption').html(jQuery(domNode).find('.active > .carousel-caption').html());

                if (jQuery(window).width() > 1023) {

                    jQuery(domNode).on('slid.bs.carousel', function () {
                        jQuery(domNode).find('.js-visma-carousel-caption').fadeOut();
                        setTimeout(
                            function () {
                                jQuery(domNode).find('.js-visma-carousel-caption').html(jQuery(domNode).find('.active > .carousel-caption').html());
                                jQuery(domNode).find('.js-visma-carousel-caption').fadeIn();
                            }, 500);
                    });
                }
                
            })
            
            //carousel progress bar 

            var percent = 0, bar = $('.transition-timer-carousel-progress-bar'),
                crsl = $('.js-visma-carousel-left-right');

            function progressBarCarousel() {
                bar.css({width: percent + '%'});
                percent = percent + 0.5;
                if (percent > 100) {
                    percent = 0;
                    crsl.carousel('next');
                }
            }

            crsl.carousel({
                interval: false,
                pause: false
            }).on('slid.bs.carousel', function () {
                percent = 0;
            });
            var barInterval = setInterval(progressBarCarousel, 30);
            /*crsl.hover(
                function () {
                    clearInterval(barInterval);
                },
                function () {
                    barInterval = setInterval(progressBarCarousel, 30);
                })*/
        }
    };
    visma.coursesAndWebinarsFiltering = {
        init: function () {
            if(jQuery('.js-filter-course-webinar-container').length > 0) {
                jQuery('.js-filter-course-webinar').on('change', function(input) {
                    visma.coursesAndWebinarsFiltering.filterItems(input.target);
                });
            }
        },
        filterItems: function(target) {
            var jOuterContainer = jQuery(target).parents('.js-filter-course-webinar-container');
            var selectedSolution = jOuterContainer.find('.js-filter-course-webinar-solution')[0].value;
            var selectedType = jOuterContainer.find('.js-filter-course-webinar-type')[0].value;
            var jItems = jQuery('.js-filter-course-webinar-item');
            jItems.stop(true, true);

            jItems.each(function(index, element) {
                var shouldFilter = false;
                var jElement = jQuery(element);
                if(selectedType && jElement.data('coursetype') && jElement.data('coursetype').split(',').indexOf(selectedType) < 0) {
                    shouldFilter = true;
                }
                if(selectedSolution && jElement.data('coursesolution') && jElement.data('coursesolution').split(',').indexOf(selectedSolution) < 0) {
                    shouldFilter = true;
                }
                if(shouldFilter) {
                    jElement.fadeOut();
                } else {
                    jElement.fadeIn();
                }
            })
        }
    };
}());


